"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TemplateCompanies {
}
exports.TemplateCompanies = TemplateCompanies;
//# sourceMappingURL=TemplateCompanies.js.map